import React from "react";
import { Link } from "react-router-dom";

const LINKS = [
  { group: "Main", items: [["Home", "/"], ["Create Invoice", "/create"], ["Invoice Preview", "/preview"]] },
  { group: "Company", items: [["About", "/about"], ["Contact", "/contact"], ["Blog", "/blog"]] },
  { group: "Support", items: [["FAQ", "/faq"], ["Sitemap", "/sitemap"]] },
  { group: "Legal", items: [["Privacy Policy", "/privacy"], ["Terms & Conditions", "/terms"]] },
];

export default function Sitemap() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-widest text-blue-600 font-semibold mb-3">Sitemap</div>
        <h1 className="font-heading text-4xl font-bold tracking-tight">Sitemap</h1>
        <p className="mt-3 text-muted-foreground">All pages of the Simple Invoice website.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {LINKS.map((g) => (
          <div key={g.group} className="rounded-2xl bg-card border border-border p-6">
            <div className="font-heading font-semibold mb-4">{g.group}</div>
            <ul className="space-y-2">
              {g.items.map(([n, h]) => (
                <li key={h}><Link to={h} className="text-sm text-muted-foreground hover:text-blue-600 transition-colors">{n}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
